import { Calculator, DollarSign, TrendingUp, Target } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { MultiModeRiskCalculator } from '@/components/risk-calculator/MultiModeRiskCalculator';

export default function RiskCalculatorPage() {
  return (
    <div className="space-y-6">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Feature Overview Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <Card className="border-border/50 bg-card/50">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-base">
                <TrendingUp className="h-4 w-4 text-primary" />
                Quick Mode
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm">
                Enter Symbol + %TP/SL + TV Position Size → Get instant $TP/$SL and cTrader lot size
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="border-border/50 bg-card/50">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-base">
                <Target className="h-4 w-4 text-primary" />
                Target Mode
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm">
                Enter target $TP/$SL amounts → Calculate required %TP/SL for your TV position
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="border-border/50 bg-card/50">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-base">
                <DollarSign className="h-4 w-4 text-primary" />
                Position Mode
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm">
                Enter risk amount + %TP/SL → Find optimal TV position size for your risk tolerance
              </CardDescription>
            </CardContent>
          </Card>
        </div>

        {/* Main Calculator */}
        <Card className="border-border/40">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Calculator className="h-5 w-5 text-primary" />
              Risk Calculator
            </CardTitle>
            <CardDescription>
              Choose your calculation mode and enter your parameters for instant results
            </CardDescription>
          </CardHeader>
          <CardContent className="p-6">
            <MultiModeRiskCalculator />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}